module.exports = __webpack_public_path__ + "static/the-telomere-effect-8be919bc74fc690ed00ad071a701c36d.jpg";